import Vue from 'vue'
import { MutationTree } from 'vuex'
import { ScheduleStateInterface } from 'src/store/schedule/state'
import { ItemTypeEnum, ItemId, Item, Section } from 'able-lib'
import { ITEM_LESSON_TEMPLATE } from 'src/lib/tools/lesson'

const mutation: MutationTree<ScheduleStateInterface> = {
  SET_SCHEDULES (state, items: Array<Item>): void {
    state.schedules = items
  },

  SET_SCHEDULE_VALUES (state, payload): void {
    state.schedule.level = payload.level
    state.schedule.subject = payload.subject
  },

  ADD_SCHEDULE_ON_LIST (state, newSchedule: Item) {
    state.schedules.push(newSchedule)
  },

  UPDATE_SCHEDULE_ON_LIST (state, updatedSchedule: Item) {
    const foundScheduleIndex = state.schedules.findIndex(schedule => schedule.id === updatedSchedule.id)
    Vue.set(state.schedules, foundScheduleIndex, updatedSchedule)
  },

  REMOVE_SCHEDULE_ON_LIST_BY_ID (state, removedScheduleId): void {
    state.schedules = state.schedules.filter(schedule => schedule.id !== removedScheduleId)
  },

  addSchedule (state, item: Item): void {
    state.schedules.push(item)
  },

  newSchedule (state: ScheduleStateInterface): void {
    state.userPicker.levelId = null
    state.userPicker.sectionId = null
  },

  updateUserPickerValues (state, { key, value }: { key: string; value: any }): void {
    state.userPicker[key] = value
  },

  setSections (state, sections: Array<Section>): void {
    const collection: Set<Section> = new Set(state.sections)

    sections.forEach(section => {
      collection.add(section)
    })

    state.sections = [...collection]
  },

  setLessonPlans (state, originalItems: Array<Item>): void {
    const collection: Array<Item> = state.originalItems.concat([])
    const ids: Array<ItemId> = collection.map((item: Item) => item.id)

    originalItems.forEach(item => {
      if (!ids.includes(item.id)) collection.push(item)
    })

    state.originalItems = [...collection]
  },

  updateLessonplan (state, lessonplan: any): void {
    const planIndex = state.originalItems.findIndex((plan) => plan.lessonPlan.id === lessonplan.id)
    state.originalItems[planIndex].lessonPlan = JSON.parse(JSON.stringify(lessonplan))
  },

  addLessonplan (state, lessonplan: any): void {
    const newPlan = ITEM_LESSON_TEMPLATE
    newPlan.lessonPlan = lessonplan
    newPlan.type = ItemTypeEnum.LESSONPLAN

    if (state.originalItems.length > 0) {
      state.originalItems.push(newPlan)
    }
  }
}

export default mutation
